import { render, staticRenderFns } from "./MarketplaceContent.vue?vue&type=template&id=506d4bf2"
import script from "./MarketplaceContent.vue?vue&type=script&lang=js"
export * from "./MarketplaceContent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceContent.vue?vue&type=style&index=0&id=506d4bf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports